export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-brush/src/event.js
// module id = 290
// module chunks = 0